const HAS_TIMEZONE_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/i;

const normalizeUtcString = (value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    return trimmed;
  }

  // If timestamp has no explicit timezone, treat it as UTC.
  if (!HAS_TIMEZONE_SUFFIX.test(trimmed)) {
    return `${trimmed}Z`;
  }

  return trimmed;
};

export const parseUtcToLocalDate = (utcLikeValue?: string): Date | null => {
  if (!utcLikeValue) {
    return null;
  }

  const normalized = normalizeUtcString(utcLikeValue);
  const parsed = new Date(normalized);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatUtcAsLocalDateTime = (utcLikeValue?: string): string => {
  const parsed = parseUtcToLocalDate(utcLikeValue);
  if (!parsed) {
    return utcLikeValue || 'N/A';
  }

  return parsed.toLocaleString();
};

export const formatUtcAsLocalTime = (utcLikeValue?: string): string => {
  const parsed = parseUtcToLocalDate(utcLikeValue);
  if (!parsed) {
    return utcLikeValue || 'N/A';
  }

  return parsed.toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3
  });
};
